import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./alert.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "C:/agent/_work/9/s/projects/afla-v2/src/app/shared/components/alert/alert.component.ts.css?ngResource!=!C:\\agent\\_work\\9\\s\\node_modules\\@ngtools\\webpack\\src\\loaders\\inline-resource.js?data=CiAgICAuYWxlcnRfbWVzc2FnZSB7CiAgICAgIHdpZHRoOiAxMDAlOwogICAgICB3aGl0ZS1zcGFjZTogbm9ybWFsOwogICAgICB3b3JkLWJyZWFrOiBicmVhay13b3JkOwogICAgfQoKICA%3D!C:/agent/_work/9/s/projects/afla-v2/src/app/shared/components/alert/alert.component.ts";
import { Component, Input } from "@angular/core";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
let AlertComponent = class AlertComponent {
    appController;
    id;
    alerts = [];
    getAlertSubscription;
    constructor(appController) {
        this.appController = appController;
    }
    ngOnInit() {
        this.getAlertSubscription = this.appController.getAlert(this.id).subscribe((alert) => {
            // if (alert.alertId === undefined) {
            //   return;
            // }
            if (!alert.message) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }
            // add alert to array
            this.alerts.push(alert);
            if (this.alerts.length >= 4) {
                this.alerts.splice(0, 1);
            }
            setTimeout(() => {
                this.alerts.splice(0, 1);
            }, 10000);
        });
    }
    removeAlert(alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }
    cssClass(alert) {
        if (!alert) {
            return;
        }
        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return "alert alert-success";
            case AlertType.Error:
                return "alert alert-danger";
            case AlertType.Info:
                return "alert alert-info";
            case AlertType.Warning:
                return "alert alert-warning";
        }
    }
    static ctorParameters = () => [
        { type: AppControllerService }
    ];
    static propDecorators = {
        id: [{ type: Input }]
    };
};
AlertComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-alert",
        template: __NG_CLI_RESOURCE__0,
        animations: [
            trigger("simpleFadeAnimation", [
                // the "restingState" style determines the "resting" state of the element when it is visible.
                state("restingState", style({ opacity: 1 })),
                // fade in when created.
                transition(":enter", [
                    style({ opacity: 0 }),
                    animate(350)
                ]),
                // fade out when destroyed.
                transition(":leave", animate(400, style({ opacity: 0 })))
            ])
        ],
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AlertComponent);
export { AlertComponent };
